import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, Card, Col, Container, Row, Modal, Form} from "react-bootstrap";
import {
    getBadge as onGetBadge,
    createBadge as onCreateBadge,
    deleteBadge as onDeleteBadge,
    updateBadge as onUpdateBadge,
} from "../../slices/badge/thunk";
import {searchBadge} from "../../helpers/helper";
import {useDispatch, useSelector} from "react-redux";
import {DeleteModal} from "../../Common/DeleteModal";
import {ToastContainer} from "react-toastify";
import {useFormik} from "formik";
import * as Yup from "yup";
import {Link} from "react-router-dom";
import TableContainer from "../../Common/TableContainer";

const Badge = () => {
    const dispatch = useDispatch<any>();
    const badge = useSelector((state: any) => state.Badge.badge);
    const [listView, setListView] = useState<any>(null);
    const [show, setShow] = useState<boolean>(false);
    const [addBadge, setAddBadge] = useState<boolean>(false);
    const [deleteItem, setDeleteItem] = useState<any>(null);
    const [editModel, setEditModel] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>(null);

    useEffect(() => {
        setListView(badge);
    }, [badge]);

    //search
    const handleChange = async (ele: any) => {
        const search = ele.target.value;
        if (search) {
            try {
                const response: any = await searchBadge({keyword: search}, {page: 0, size: 500});
                setListView(response.content);
            } catch (error) {
                setListView([]);
            }
        } else {
            setListView(badge);
        }
    };
    const handleCloseBadge = () => {
        setEdit(null);
        setAddBadge(false);
    }
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddBadge(true)
        setEditModel(true);
        setEdit({
            id: lastItem.id,
            title: lastItem.displayName,
            color: lastItem.heh,
        });
        console.log(lastItem)

    }, []);

    const handleShowBadge = () => setAddBadge(true);
    const handleDeleteClose = () => setShow(false);

    //delete modal
    const deleteModalFunction = () => {
        if (deleteItem) {
            dispatch(onDeleteBadge(deleteItem.id));
        }
        setShow(false);
    };

    useEffect(() => {
        dispatch(onGetBadge())
    }, [dispatch]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Color",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <div className={`w-50 color-picker border`} style={{backgroundColor: `${cell.row.original.heh}`}}>
                        </div>
                    )
                }
            },

            {
                header: "Badge Name",
                accessorKey: "displayName",
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: "Created At",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Updated At",
                accessorKey: "updatedAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell.row.original)}><i
                                    className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );


    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: (edit && edit.title) || '',
            id: edit && edit.id,
            color: (edit && edit.color) || ''
        },

        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Your Badge name"),
            color: Yup.string().required("Please Enter Your Order"),
        }),

        onSubmit: (values: any) => {
            if (editModel) {
                const data: any = {
                    displayName: values.title,
                    heh: values.color,
                    id: values.id
                }
                dispatch(onUpdateBadge(data));
                formik.resetForm();

            } else {
                const data: any = {
                    displayName: values.title,
                    heh: values.color,
                }

                console.log(data);
                dispatch(onCreateBadge(data));
                formik.resetForm();
            }
            if (values === null) {
                handleShowBadge();
            } else {
                setEdit(null);
                setEditModel(false);
                handleCloseBadge();
            }
        }
    });

    const handleDeleteShow = (item: any) => {
        setShow(true);
        setDeleteItem(item);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row id="categoryList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Badge</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search badge..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button variant="secondary" onClick={handleShowBadge}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Create
                                                    Badge
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {Array.isArray(listView) && listView.length > 0 ? (
                                        <>
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                // isBcolored={false}
                                            />
                                        </>
                                    ) : (
                                        <div id="noresult">
                                            <div className="text-center py-4">
                                                <div className="avatar-md mx-auto mb-4">
                                                    <div
                                                        className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                        <i className="bi bi-search"></i>
                                                    </div>
                                                </div>
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                            </div>
                                        </div>
                                    )}
                                </Card.Body>

                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addBadge} onHide={handleCloseBadge}>
                <Modal.Header closeButton>
                    <Modal.Title>{editModel ? "update Badge List" : "Add Badge"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-3">
                            <Form.Label htmlFor="Customer-Name-input">Title<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="Customer-Name-input"
                                name="title"
                                placeholder="Title"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.title}
                            />
                            {formik.errors.title && formik.touched.title ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.title}</Form.Control.Feedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Form.Label htmlFor="color-input">Order<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="color"
                                id="color-input"
                                name="color"
                                placeholder="Order"
                                className={"form-control form-control-color w-100"}
                                value={formik.values.color}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.color}
                            />
                            {formik.errors.color && formik.touched.color ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.color}</Form.Control.Feedback>
                            ) : null}
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseBadge}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button type="submit" variant="primary"
                                id="add-btn">{editModel ? "update" : "Add Badge"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <ToastContainer/>
        </React.Fragment>
    )
}

export default Badge;